/* eslint-disable */
import elasticlunr from "elasticlunr"
import * as usaStates from '../api/usastates.json';

elasticlunr.clearStopWords();

const search_config = {
  initFunction: {},
  queryConfig: {},
  indexFunction: {},
  indexes:{}
}

search_config.initIndex = function(indexName) {
  this.indexes[indexName] = elasticlunr(this.initFunction[indexName])
  return this.indexes[indexName]
}

// Place component search
search_config.initFunction['PLACE_COMPONENT'] = function () {
  this.setRef('id')
  this.addField('country')
  this.addField('state')
  this.addField('city')
  this.addField('postalCode')
  this.addField('branch')
}

search_config.queryConfig['PLACE_COMPONENT'] = {
  'country': { fields: { 'state': {boost: 1} }, bool: 'AND', expand: true },
  'state': { fields: { 'state': {boost: 1} }, bool: 'AND', expand: true },
  'city': { fields: { 'city': {boost: 1} }, bool: 'AND', expand: true },
  'postalCode': { fields: { 'postalCode': {boost: 1} }, bool: 'AND', expand: true },
  'branch': { fields: { 'branch': {boost: 1} }, bool: 'AND', expand: true }
}

search_config.indexFunction['PLACE_COMPONENT'] = function (item, searchIndex) {
//   console.log(item.address)
   let countryId = item.address.addressCountry != null ? item.address.addressCountry.toUpperCase() : ""
   let stateId = item.address.addressRegion.toUpperCase() + "|" + countryId
   let cityId = item.address.addressLocality.toUpperCase() + "|" + stateId
   let postalCodeId = item.address.postalCode.toUpperCase() + "|" + cityId
  
   if (!searchIndex.documentStore.hasDoc(countryId) && item.address.addressCountry) {
      let doc = {}
      doc['id'] = countryId
      doc['country'] = item.address.addressCountry
      searchIndex.addDoc(doc)
      //console.log('Adding country ' +  countryId)
   }

    if (!searchIndex.documentStore.hasDoc(stateId) && item.address.addressRegion) {
      let doc = {}
      doc['id'] = stateId
      doc['state'] = usaStates[item.address.addressRegion] + ", " + item.address.addressRegion + ", " + item.address.addressCountry
      searchIndex.addDoc(doc)
      //console.log('Adding state ' +  stateId)
   }

   if (!searchIndex.documentStore.hasDoc(cityId) && item.address.addressLocality) {
      let doc = {}
      doc['id'] = cityId
      doc['city'] = item.address.addressLocality + ", " + usaStates[item.address.addressRegion] + ", " + item.address.addressRegion + ", " + item.address.addressCountry
      searchIndex.addDoc(doc)
      //console.log('Adding city' +  cityId)
   }

   if (!searchIndex.documentStore.hasDoc(postalCodeId) && item.address.postalCode) {
      let doc = {}
      doc['id'] = postalCodeId
      doc['postalCode'] = item.address.postalCode + ", " + item.address.addressLocality + ", " + usaStates[item.address.addressRegion] + ", " + item.address.addressRegion + ", " + item.address.addressCountry
      searchIndex.addDoc(doc)
      //console.log('Adding postalCode ' +  postalCodeId)
   }

   if (!searchIndex.documentStore.hasDoc(item.id) && item.id) {
      let doc = {}
      doc['id'] = item.id
      doc['branch'] = "#"+ item.id +" - "+ item.address.streetAddress + ", " + item.address.postalCode + ", " + item.address.addressLocality + ", " + usaStates[item.address.addressRegion] + ", " + item.address.addressRegion + ", " + item.address.addressCountry
      searchIndex.addDoc(doc)
      //console.log('Adding postalCode ' +  postalCodeId)
   }

}  


// [ LocalBusiness ]

search_config.initFunction['LocalBusinesses'] = function () {
  this.setRef('id');
  this.addField('all') 
  this.addField('branchCode') 
  this.addField('address.streetAddress') 
  this.addField('address.addressLocality') 
  this.addField('address.addressRegion') 
    
}

search_config.queryConfig['LocalBusinesses'] = {
  'all': { fields: { 'all' : { boost: 1 } }, bool: 'AND', expand: true  },
  'branchCode': { fields: { 'branchCode': {boost: 1} }, bool: 'AND', expand: true },
  'address.streetAddress': { fields: { 'address.streetAddress': {boost: 1} }, bool: 'AND', expand: true },
  'address.addressLocality': { fields: { 'address.addressLocality': {boost: 1} }, bool: 'AND', expand: true },
  'address.addressRegion': { fields: { 'address.addressRegion': {boost: 1} }, bool: 'AND', expand: true },
}

search_config.indexFunction['LocalBusinesses'] = function (item, searchIndex) {
  let doc = {}
  doc['id'] = item.id
  doc['all'] = ""  
  doc['branchCode'] = item.branchCode
  doc['all'] = doc['all'] + item.branchCode + " "
  doc['address.streetAddress'] = item.address.streetAddress
  doc['all'] = doc['all'] + item.address.streetAddress + " "
  doc['address.addressLocality'] = item.address.addressLocality
  doc['all'] = doc['all'] + item.address.addressLocality + " "
  doc['address.addressRegion'] = item.address.addressRegion
  doc['all'] = doc['all'] + item.address.addressRegion + " "
  searchIndex.addDoc(doc) 
}


// [ Offer ]

search_config.initFunction['Offer'] = function () {
  this.setRef('id');
  this.addField('all') 
  this.addField('businessFunction') 
  this.addField('alternateName') 
  this.addField('name') 
    
}

search_config.queryConfig['Offer'] = {
  'all': { fields: { 'all' : { boost: 1 } }, bool: 'AND', expand: true  },
  'businessFunction': { fields: { 'businessFunction': {boost: 1} }, bool: 'AND', expand: true },
  'alternateName': { fields: { 'alternateName': {boost: 1} }, bool: 'AND', expand: true },
  'name': { fields: { 'name': {boost: 1} }, bool: 'AND', expand: true },
}

search_config.indexFunction['Offer'] = function (item, searchIndex) {
  let doc = {}
  doc['id'] = item.id
  doc['all'] = ""  
  doc['businessFunction'] = item.businessFunction
  doc['all'] = doc['all'] + item.businessFunction + " "
  doc['alternateName'] = item.alternateName
  doc['all'] = doc['all'] + item.alternateName + " "
  doc['name'] = item.name
  doc['all'] = doc['all'] + item.name + " "
  searchIndex.addDoc(doc) 
}

search_config.initFunction['Uploads'] = function () {
  this.setRef('id');
  this.addField('all') 
  this.addField('filename') 
  this.addField('original_filename') 
    
}

search_config.queryConfig['Uploads'] = {
  'all': { fields: { 'all' : { boost: 1 } }, bool: 'AND', expand: true  },
  'filename': { fields: { 'filename': {boost: 1} }, bool: 'AND', expand: true },
  'original_filename': { fields: { 'original_filename': {boost: 1} }, bool: 'AND', expand: true },
}

search_config.indexFunction['Uploads'] = function (item, searchIndex) {
  let doc = {}
  doc['id'] = item.id
  doc['all'] = ''
  doc['filename'] = item.filename
  doc['all'] = doc['all'] + item.filename + ' '
  doc['original_filename'] = item.original_filename
  doc['all'] = doc['all'] + item.original_filename + ' '
  searchIndex.addDoc(doc) 
}


export default search_config



// WEBPACK FOOTER //
// ./src/search/index.js